<template>
  <v-menu
    v-model="showDialog"
    :close-on-content-click="false"
    :nudge-right="40"
    transition="scale-transition"
    offset-y
  >
    <template v-slot:activator="{ on }">
      <v-text-field
        :class="getAlign"
        hide-details
        :value="formatDate"
        :label="label"
        readonly
        :clearable="clearable"
        v-on="on"
        @click:clear="compdate = null"
      ></v-text-field>
    </template>
    <v-date-picker dense v-model="compdate" @input="showDialog = false"></v-date-picker>
  </v-menu>
</template>

<script>
import { getFormattedDate } from "../shared.js";

export default {
  props: {
    label: String,
    date: String,
    clearable: {
      type: Boolean,
      default: false
    },
    align: String
  },
  data() {
    return {
      showDialog: false,
      date2: this.date
    };
  },
  watch: {
    // listen out for changes to the underlying incoming 'date' property since this
    // instance is already created and is re-used through the Dialogs!
    date: function(newValue) {
      this.date2 = newValue;
    }
  },
  computed: {
    compdate: {
      get() {
        return this.date2;
      },
      set(newValue) {
        if (newValue == null || newValue == undefined) newValue = "";
        this.date2 = newValue;
        this.$emit("date-changed", newValue);
      }
    },
    formatDate() {
      return getFormattedDate(this.date2);
    },
    getAlign() {
      if (this.align == "center") return "align-center-input";
      else if (this.align == "right") return "align-right-input";
      else return "";
    }
  }
};
</script>

<style>
.align-right-input input {
  text-align: right;
}
.align-center-input input {
  text-align: center;
}
</style>